// @flow
import {
  DELETE_TREATMENT_LOADING,
  DELETE_TREATMENT_SUCCESS,
  DELETE_TREATMENT_ERROR,
  ADD_TREATMENT_LOADING,
  ADD_TREATMENT_SUCCESS,
  ADD_TREATMENT_ERROR,
  UPDATE_TREATMENT_LOADING,
  UPDATE_TREATMENT_SUCCESS,
  UPDATE_TREATMENT_ERROR,
} from '../actions/treatmentActions';

export default (state: Object = {}, action: Object) => {
  switch (action.type) {
    case DELETE_TREATMENT_LOADING:
    case ADD_TREATMENT_LOADING:
    case UPDATE_TREATMENT_LOADING:
      return {
        ...state,
        status: 'LOADING',
      };
    case DELETE_TREATMENT_SUCCESS:
    case ADD_TREATMENT_SUCCESS:
    case UPDATE_TREATMENT_SUCCESS:
      return {
        ...state,
        status: 'SUCCESS',
        data: action.data,
      };
    case DELETE_TREATMENT_ERROR:
    case ADD_TREATMENT_ERROR:
    case UPDATE_TREATMENT_ERROR:
      return {
        ...state,
        status: 'ERROR',
        error: action.error,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./client/src/reducers/treatmentReducer.js